// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-bar-icon .icon-button__icon{margin-top:-2px}`, "",{"version":3,"sources":["webpack://./src/components/floating-bar/floating-bar-icon.css"],"names":[],"mappings":"AAAA,sCAEC,eACD","sourcesContent":[".floating-bar-icon .icon-button__icon {\n\t/* Move a bit up to more visually center the icons */\n\tmargin-top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
